// Utilities for converting Emscripten-bound C++ objects into plain JS objects.

export function vecToArray(vec) {
    const arr = [];
    for (let i = 0; i < vec.size(); i++) arr.push(vec.get(i));
    return arr;
}

export function parseTerm(t) {
    return {
        termType:        t.term_type,
        integerValue:    t.integer_value,
        identifierIdx:   t.identifier_idx,
        children:        vecToArray(t.children),
        isBound:         t.is_bound,
        boundTo:         t.bound_to,
        varIdentifierIdx: t.var_identifier_idx,
        varVersion:      t.var_version,
    };
}

export function parseFrame(f) {
    return {
        type:           f.type,
        index:          f.index,
        parent:         f.parent,
        decisionIndex:  f.decision_index,
        cutPoint:       f.cut_point,
        originalClause: f.original_clause,
        continuation:       { next: f.continuation.next,        remains: f.continuation.remains },
        parentContinuation: { next: f.parent_continuation.next, remains: f.parent_continuation.remains },
    };
}

export function parseSnapshot(snap) {
    return {
        solverState:     snap.solverState,
        lastStep:        snap.last_step,
        lastClauseIndex: snap.last_clause_index,
        stack:           vecToArray(snap.stack).map(parseFrame),
        history:         vecToArray(snap.history).map(dp => ({
            stackIndex:    dp.stack_index,
            decisionIndex: dp.decision_index,
            type:          dp.type,
        })),
        trail:           vecToArray(snap.trail),
        stackPointer:    snap.stack_pointer,
        atEnd:           snap.at_end,
        solutionFound:   snap.solution_found,
        termVec:         vecToArray(snap.term_vector).map(parseTerm),
        error:           snap.error,
        errorIsInternal: snap.error_is_internal,
    };
}
